<section id="tool" class="container">
  <div *ngIf="true" class="row justify-content-center">
    <div class="col-11 col-lg-9">
      <div class="header row">
        <div class="column">
          <h1>
            Tool
            <h2 *ngIf="tool; else env" class="link">
              {{ tool?.environment?.name }} > {{ tool?.name }}
            </h2>
            <ng-template #env>
              <h2 *ngIf="environment" class="link">{{ environment.name }}</h2>
            </ng-template>
          </h1>
        </div>
        <div class="buttons column">
          <button
            kendoButton
            (click)="deleteTool()"
            icon="trash"
            fillMode="outline"
            themeColor="primary"
          ></button>
          <button
            class="ml-2"
            kendoButton
            [disabled]="!toolForm.valid"
            (click)="saveTool()"
            themeColor="primary"
          >
            Save
          </button>
        </div>
      </div>
      <div class="row">
        <cyborg-notice>
          Please note that any environment changes will not affect existing
          hunts and hunt templates; they will only apply to future hunts.
        </cyborg-notice>
        <form
          style="width: 100%"
          [formGroup]="toolForm"
          class="k-form pt-4"
          [ngClass]="{ editing: isEditing }"
        >
          <fieldset style="width: 450px" class="k-form-fieldset">
            <legend class="k-form-legend">Tool Details</legend>
            <kendo-formfield>
              <kendo-label [for]="name" text="Name"></kendo-label>
              <input
                formControlName="name"
                [clearButton]="true"
                #name
                required
              />
              <kendo-formerror>Tool name is required</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label [for]="product" text="Tool"></kendo-label>
              <kendo-dropdownlist
                #product
                formControlName="product"
                [style.width]="'100%'"
                [data]="groupedData"
                textField="name"
                valueField="name"
                [valuePrimitive]="true"
                (valueChange)="valueChange($event)"
              >
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                  <img width="20px" [src]="getToolIcon(dataItem.name)" />
                  {{ dataItem.name }}
                </ng-template>
              </kendo-dropdownlist>
              <kendo-formerror>Tool is required</kendo-formerror>
            </kendo-formfield>
            <kendo-formfield *ngIf="supportedToolUrl(toolForm.value.product)">
              <div>
                <kendo-label [for]="url" text="Root URL"></kendo-label>
                <input
                  formControlName="rootUrl"
                  [clearButton]="true"
                  [style.width]="'100%'"
                  placeholder="https://www.tool.example.com/"
                  #url
                />
              </div>
              <!-- <div style="float: right">
                <a
                  [class.disabled]="toolForm.controls.rootUrl.invalid"
                  (click)="testUrl()"
                  style="margin-top: 25px; margin-left: 15px"
                  class="outline button medium"
                  target="_blank"
                  >Test</a
                >
              </div> -->
            </kendo-formfield>
          </fieldset>
          <fieldset *ngIf="customMapping" class="k-form-fieldset">
            <div>
              <div style="width: 450px">
                <legend class="k-form-legend">Field Mappings</legend>
                <span class="link add-data-source" (click)="addFieldMapping()"
                  >+ Add new field mapping</span
                >
              </div>
              <div
                class="mt-4"
                style="width: 450px"
                formArrayName="fieldMappings"
              >
                <details
                  *ngFor="
                    let fieldMapping of fieldMappings().controls;
                    let i = index
                  "
                  [formGroupName]="i"
                  [attr.open]="openIndexes.has(i) || null"
                  (toggle)="onToggle(i, $event)"
                >
                  <summary>
                    <h6
                      *ngIf="fieldMapping.value.name; else default"
                      class="link"
                    >
                      {{ fieldMapping.value.name }}&nbsp;
                    </h6>
                    <ng-template #default>
                      <h6 class="link">Field Mapping {{ i + 1 }}</h6>
                    </ng-template>
                  </summary>
                  <div class="content">
                    <fieldset class="k-form-fieldset">
                      <legend class="k-form-legend">
                        Field Mapping Details
                      </legend>
                      <kendo-formfield>
                        <kendo-label for="name" text="Name"></kendo-label>
                        <input
                          formControlName="name"
                          [clearButton]="true"
                          #name
                          required
                        />
                      </kendo-formfield>
                      <div formArrayName="toolSpecific">
                        <kendo-formfield
                          *ngFor="
                            let field of toolSpecificFields(i).controls;
                            let j = index
                          "
                          [formGroupName]="j"
                        >
                          <kendo-label
                            for="field"
                            text="{{ getReadableName(getFieldName(field)) }}"
                          ></kendo-label>
                          <input
                            formControlName="{{ getFieldName(field) }}"
                            [clearButton]="true"
                            required
                          />
                        </kendo-formfield>
                      </div>
                    </fieldset>
                    <fieldset class="k-form-fieldset">
                      <legend style="display: inline" class="k-form-legend">
                        Field Mapping Configuration
                        <button
                          style="float: right"
                          kendoButton
                          themeColor="primary"
                          [disabled]="fieldMapping.value.category.length == 0"
                          (click)="applyDefaults(i)"
                        >
                          Apply Defaults
                        </button>
                      </legend>
                      <kendo-formfield>
                        <kendo-label
                          for="category"
                          text="Category"
                        ></kendo-label>
                        <kendo-dropdownlist
                          formControlName="category"
                          [data]="categoryData"
                          textField="name"
                          valueField="category"
                          [valuePrimitive]="true"
                          (valueChange)="populateCategoryFields($event, i)"
                        >
                        </kendo-dropdownlist>
                      </kendo-formfield>
                      <div formArrayName="fields">
                        <kendo-formfield
                          *ngFor="
                            let field of fieldMappingFields(i).controls;
                            let j = index
                          "
                          [formGroupName]="j"
                        >
                          <kendo-label
                            for="field"
                            text="{{
                              getReadableFieldName(getFieldName(field))
                            }}"
                          ></kendo-label>
                          <input
                            formControlName="{{ getFieldName(field) }}"
                            [clearButton]="true"
                          />
                          <kendo-formhint
                            *ngIf="
                              getFieldDescription(getFieldName(field)) != ''
                            "
                            >{{
                              getFieldDescription(getFieldName(field))
                            }}</kendo-formhint
                          >
                        </kendo-formfield>
                      </div>
                      <button
                        style="float: right"
                        class="mt-4"
                        icon="delete"
                        themeColor="error"
                        fillMode="outline"
                        size="medium"
                        (click)="removeFieldMapping(i)"
                        kendoButton
                      ></button>
                    </fieldset>
                  </div>
                </details>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
  <ng-template #loading>
    <div class="loading">
      <kendo-loader type="pulsing" themeColor="primary" size="large">
      </kendo-loader>
    </div>
  </ng-template>
</section>
